/** Talent dashboard chrome. Profile catalogs come from catalogs/*. */
const dictionary = {
  en: {
    welcome: "Welcome {name}",
  },
  de: {
    welcome: "Willkommen {name}",
  },
  "fi": {
    "welcome": "Tervetuloa, {name}"
  }
};

export default dictionary;
